/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketItemShopListRequest model module.
 * @module model/MarketItemShopListRequest
 * @version 1.0
 */
class MarketItemShopListRequest {
    /**
     * Constructs a new <code>MarketItemShopListRequest</code>.
     * @alias module:model/MarketItemShopListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MarketItemShopListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MarketItemShopListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketItemShopListRequest} obj Optional instance to populate.
     * @return {module:model/MarketItemShopListRequest} The populated <code>MarketItemShopListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketItemShopListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('listType')) {
                obj['listType'] = ApiClient.convertToType(data['listType'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketItemShopListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketItemShopListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MarketItemShopListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

MarketItemShopListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MarketItemShopListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MarketItemShopListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MarketItemShopListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} listType
 */
MarketItemShopListRequest.prototype['listType'] = undefined;






export default MarketItemShopListRequest;

